import { createGlobalState } from '@vueuse/core';
import { ref } from 'vue';

const useProjectsContractsActionState = createGlobalState(() => {
  const mode = ref<'' | 'new-contract' | 'contract-actions'>('');
  return { mode };
});

export default useProjectsContractsActionState;
